import * as React from 'react';

interface ScacCellProps {
  scac: string;
  carrier: string;
  mode: string;
}
export function ScacCell(props: ScacCellProps) {
  return (
    <div className="flexe-mui-data-grid-subtitle-cell">
      <div className="title">{props.scac ? props.scac : props.carrier}</div>
      <div className="subtitle">{props.mode}</div>
    </div>
  );
}
